import { ProductItemTypes } from '../enums';
import { ProductItemModel, RaffleCountDownModel } from '../models';

export const getRaffleCountdownText = (startsAt: Date | null, endsAt: Date | null): RaffleCountDownModel => {
   if (!startsAt || !endsAt) {
      const res: RaffleCountDownModel = {
         isLive: false,
         title: {
            short: '',
            long: '',
         },
         hours: null,
         minutes: null,
      };

      if (!startsAt && !endsAt) {
         res.isLive = true;
         return res;
      }

      if ((startsAt && new Date(startsAt).getTime() <= Date.now()) || (endsAt && new Date(endsAt).getTime() >= Date.now())) {
         res.isLive = true;

         if (endsAt && new Date(endsAt).getTime() >= Date.now()) {
            res.title = {
               short: 'Ending in',
               long: 'Ending in',
            };

            const h = Math.floor((new Date(endsAt).getTime() - Date.now()) / 1000 / 60 / 60);
            if (h > 24) {
               res.hours = h;
            } else {
               res.hours = Math.floor((new Date(endsAt).getTime() - Date.now()) / 1000 / 60 / 60);
               res.minutes = Math.floor(((new Date(endsAt).getTime() - Date.now()) / 1000 / 60) % 60);
            }
         }
      }

      return res;
   }

   const now = new Date();
   const startsAtDate = new Date(startsAt);
   const endsAtDate = new Date(endsAt);
   let title = {
      short: '',
      long: '',
   };
   let hours = null;
   let minutes = null;
   let isLive = false;

   if (now < startsAtDate) {
      title = {
         short: 'Starting in',
         long: 'Starting in',
      };
      const h = Math.floor((startsAtDate.getTime() - now.getTime()) / 1000 / 60 / 60);
      if (h > 24) {
         hours = h;
      } else {
         //  countdown = `${Math.floor((startsAtDate.getTime() - now.getTime()) / 1000 / 60 / 60)}H ${Math.floor(((startsAtDate.getTime() - now.getTime()) / 1000 / 60) % 60)}M`;
         hours = Math.floor((startsAtDate.getTime() - now.getTime()) / 1000 / 60 / 60);
         minutes = Math.floor(((startsAtDate.getTime() - now.getTime()) / 1000 / 60) % 60);
      }
   } else if (now < endsAtDate) {
      title = {
         short: 'Ending in',
         long: 'Ending in',
      };
      isLive = true;
      const h = Math.floor((startsAtDate.getTime() - now.getTime()) / 1000 / 60 / 60);
      if (h > 24) {
         hours = hours;
      } else {
         hours = Math.floor((endsAtDate.getTime() - now.getTime()) / 1000 / 60 / 60);
         minutes = Math.floor(((endsAtDate.getTime() - now.getTime()) / 1000 / 60) % 60);
         //  countdown = `${Math.floor((endsAtDate.getTime() - now.getTime()) / 1000 / 60 / 60)}H ${Math.floor(((endsAtDate.getTime() - now.getTime()) / 1000 / 60) % 60)}M`;
      }
   } else {
      title = {
         short: '',
         long: '',
      };
   }

   return { isLive, title, hours, minutes };
};

export const groupRaffleItemsByLevel = (productItems: ProductItemModel[]): Record<number, ProductItemModel[]> => {
   const groupedItems: Record<number, ProductItemModel[]> = {};

   productItems.forEach((productItem) => {
      if (productItem.type !== ProductItemTypes.RAFFLE) return;

      const level = productItem.levelRequired || 0;

      if (!groupedItems[level]) {
         groupedItems[level] = [];
      }

      groupedItems[level].push(productItem);
   });

   return groupedItems;
};

export const getWinningProbability = (productItem: ProductItemModel, quantitySimulation: number = 0): number => {
   // Ensure raffle stats are present
   if (!productItem.raffleStats) {
      return 0;
   }

   const { totalEntries, userEntries } = productItem;

   // Calculate total entries including the user's simulated entries
   const newTotalEntries = (totalEntries ?? 0) + quantitySimulation;
   const newUserEntries = (userEntries ?? 0) + quantitySimulation;
   const stock = productItem.stock ?? 0;

   // If there are no entries, the probability is 0
   if (totalEntries === 0) {
      return 0;
   }

   // Calculate the probability of not winning for the user
   let probabilityOfLosing = 1;

   // Loop to calculate the probability of losing for each winning spot
   for (let i = 0; i < stock; i++) {
      probabilityOfLosing *= (newTotalEntries - newUserEntries - i) / (newTotalEntries - i);
   }

   // The probability of winning is the complement of the probability of losing
   const probabilityOfWinning = 1 - probabilityOfLosing;

   // Return the probability of winning
   return probabilityOfWinning * 100;
};

// export const getProductOrderByValue = (friendlyValue: string): PRODUCT_ITEM_ORDER_BY => {
//    switch (friendlyValue) {
//       case PRODUCT_ITEM_ORDER_BY_FRIENDLY.PRICE_DESC:
//          return PRODUCT_ITEM_ORDER_BY.PRICE_DESC;
//       case PRODUCT_ITEM_ORDER_BY_FRIENDLY.PRICE_ASC:
//          return PRODUCT_ITEM_ORDER_BY.PRICE_ASC;
//       default:
//          return PRODUCT_ITEM_ORDER_BY.PRICE_ASC;
//    }
// };
